import { LazyLoadImageProps } from 'react-lazy-load-image-component';
// @mui
import { Theme } from '@mui/material/styles';
import { BoxProps, SxProps } from '@mui/material';
import Image from 'src/components/Image';
import { useEffect, useState } from 'react';
import { toMinioBase64 } from 'src/backoffice-app-code/utils/imageUtils';

// ----------------------------------------------------------------------

export type ImageRato = '4/3' | '3/4' | '6/4' | '4/6' | '16/9' | '9/16' | '21/9' | '9/21' | '1/1';

type IProps = BoxProps & LazyLoadImageProps;

interface Props extends IProps {
  absolutePath: string | undefined;
  sx?: SxProps<Theme>;
  ratio?: ImageRato;
  disabledEffect?: boolean;
}

export default function MinioImage({
  absolutePath,
  ratio,
  disabledEffect = false,
  effect = 'blur',
  sx,
  ...other
}: Props) {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);
  useEffect(() => {
    async function setImageUrlAsync() {
      if (!absolutePath) return;
      const token = await toMinioBase64(absolutePath);
      setImageUrl(token);
    }
    setImageUrlAsync();
  }, [absolutePath]);

  return (
    <Image
      src={imageUrl || '/assets/placeholder.svg'}
      ratio={ratio}
      disabledEffect={disabledEffect}
      effect={effect}
      sx={sx}
      {...other}
    />
  );
}
